export const productMeasurements = {
    completeFats: ['Saturated Fat', 'Polyunsaturated Fat', 'Monounsaturated Fat', 'Trans Fat'],
    carbsList: [
        'Added sugars',
        'Sugar Alcohol',
        'Other Carbohydrate',
        'Dietary Fiber',
        // 'Sugars',
        'Total sugars',
    ],
    productContains: ['Milk', 'Wheat', 'Soy', 'Gluten free'],
    nutrientMeasurements: ['g', 'mg', 'mcg'],
    defaultNutrients: ['Vitamin D', 'Calcium', 'Potassium', 'Iron'],
    otherNutrients: [
        'Vitamin A',
        'Vitamin B',
        'Vitamin C',
        'Vitamin D',
        'Vitamin K',
        'Thiamin',
        'Riboflavin',
        'Niacin',
        'Pantothenic acid',
        'Biotin',
        'Folate',
        'Cobalamin',
        'Choline',
        'Calcium',
        'Chloride',
        'Chromium',
        'Copper',
        'Fluoride',
        'Iodine',
        'Iron',
        'Magnesium',
        'Manganese',
        'Molybdenum',
        'Phosphorus',
        'Potassium',
        'Selenium',
        'Sodium',
        'Zinc',
    ],
}
